// extracted by mini-css-extract-plugin
export default {"boardItemBox":"BoardListItem_boardItemBox__8S0lO","best":"BoardListItem_best__QPZjx","itemInfo":"BoardListItem_itemInfo__BZJCB"};